
<div class="custom-angular-editor-component">
  <div class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
    <ngx-editor [editor]="editor" class="editor" [style] = "{height: pxToRem(height)}"
    [formControl]="formControl" [disabled]="false" 
    [placeholder]="placeholder"></ngx-editor>
  </div>
</div>
